import { render, staticRenderFns } from "./ColorPickerInput.vue?vue&type=template&id=16cdc640&scoped=true&"
import script from "./ColorPickerInput.vue?vue&type=script&lang=js&"
export * from "./ColorPickerInput.vue?vue&type=script&lang=js&"
import style0 from "./ColorPickerInput.vue?vue&type=style&index=0&id=16cdc640&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cdc640",
  null
  
)

export default component.exports